import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
};

export const useIsMediumScreen = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'));
};
